export const STATIC_CONSTANTS = {
  MARKETING_URL: 'https://www.checkmate.tech',
  FALLBACK_EXPIRATION_DATE: '9999-12-31',
};

// Directs candidates to the start of the relevant spent-convictions act/section for their
// jurisdiction (CMP-1062). ACIC rules forbid us from advising on results, so these links only
// point to the source legislation — never interpretive/advisory content.
export const SPENT_CONVICTIONS_LEGISLATION_LINKS = [
  {
    jurisdiction: 'Commonwealth',
    act: 'Crimes Act 1914, s 85ZM',
    url: 'https://classic.austlii.edu.au/au/legis/cth/consol_act/ca191482/s85zm.html',
  },
  {
    jurisdiction: 'New South Wales',
    act: 'Criminal Records Act 1991, s 8',
    url: 'https://classic.austlii.edu.au/au/legis/nsw/consol_act/cra1991167/s8.html',
  },
  {
    jurisdiction: 'Victoria',
    act: 'Spent Convictions Act 2021, s 8',
    url: 'https://classic.austlii.edu.au/au/legis/vic/consol_act/sca2021222/s8.html',
  },
  {
    jurisdiction: 'Queensland',
    act: 'Criminal Law (Rehabilitation of Offenders) Act 1986, s 3',
    url: 'https://classic.austlii.edu.au/au/legis/qld/consol_act/clooa1986356/s3.html',
  },
  {
    jurisdiction: 'Western Australia',
    act: 'Spent Convictions Act 1988, s 6 / s 7',
    url: 'https://www.legislation.wa.gov.au/legislation/statutes.nsf/main_mrtitle_912_homepage.html',
  },
  {
    jurisdiction: 'South Australia',
    act: 'Spent Convictions Act 2009, s 8',
    url: 'https://classic.austlii.edu.au/au/legis/sa/consol_act/sca2009222/s8.html',
  },
  {
    jurisdiction: 'Tasmania',
    act: 'Annulled Convictions Act 2003, s 6',
    url: 'https://classic.austlii.edu.au/au/legis/tas/consol_act/aca2003228/s6.html',
  },
  {
    jurisdiction: 'Australian Capital Territory',
    act: 'Spent Convictions Act 2000, s 13',
    url: 'https://classic.austlii.edu.au/au/legis/act/consol_act/sca2000222/s13.html',
  },
  {
    jurisdiction: 'Northern Territory',
    act: 'Criminal Records (Spent Convictions) Act 1992, s 6',
    url: 'https://classic.austlii.edu.au/au/legis/nt/consol_act/crca1992368/s6.html',
  },
];
